import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../helpers/reselectHelpers';
import {DomainModel} from '../../../models/api/domainModel';
import {
  ContactDetailsOrContactsManagerPanelId,
  createAccountFormUpdateAvatarFileAction,
  createAccountFormUpdateDescriptionAction,
  createAccountFormUpdateDomainsAction,
  createAccountFormUpdateNameAction,
} from '../../../store/panels/accounts/createAccountForm/createAccountFormActions';
import {CreateAccountForm} from './createAccountForm';

/*
 * Props.
 */

interface CreateAccountFormContainerProps {
  panelId: ContactDetailsOrContactsManagerPanelId;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<CreateAccountFormContainerProps>()((props) => ({
  updateName: (name: string) => createAccountFormUpdateNameAction(props.panelId, name),
  updateDescription: (description: string) =>
    createAccountFormUpdateDescriptionAction(props.panelId, description),
  updateAvatarFile: (file: File) => createAccountFormUpdateAvatarFileAction(props.panelId, file),
  updateDomains: (domains: ReadonlyArray<DomainModel>) =>
    createAccountFormUpdateDomainsAction(props.panelId, domains),
}));

export const CreateAccountFormContainer = connect(null, mapDispatchToProps)(CreateAccountForm);
